import { ReactElement } from "react";

import { formatHHmmTime, useTimezone } from "@ryde/shared";

import { IRenderColumnTemplate, TextCellTemplate } from "../../dynamic-forms";

export const TimeTextCellTemplate = ({
  timeFormat,
  value,
  ...props
}: IRenderColumnTemplate): ReactElement => {
  const { timezone } = useTimezone();
  return (
    <TextCellTemplate
      {...props}
      value={value}
      valueTranslated={formatHHmmTime(value, timeFormat, timezone)}
    />
  );
};
